export default __webpack_public_path__ + "static/image2-77c2f000cec375c8e070e105b5f88152.gif";